import {reatomContext} from '@reatom/react'
import {useContext} from 'react'

export function useReatomStore() {
  return useContext(reatomContext)
}
